export const yupValidatePhoneNumberFormat = (value: string | null | undefined): boolean => {
  const rawValue = (value || '').replace(/[\s-_]/g, '');
  if (!!rawValue) {
    return rawValue.match(/(^1300\d{6}$)|(^1800|1900|1902\d{6}$)|(^0[2|3|7|8]{1}[0-9]{8}$)|(^13\d{4}$)|(^04\d{2,3}\d{6}$)/) !== null;
  }
  return true;
};
